module.exports = "/_next/static/images/Router-38d97795b34c26d3b798df5a783a6b7a.png";